import type { ListBuilderList } from '../../../types';

/**
 * Discrepancies list — matched licenses where the stored client_license
 * value disagrees with the matched registry value for one of the
 * user-visible fields (license number, expiration date). Surfaces stale
 * data the user can resolve by either accepting the registry value
 * (unmatching is unnecessary — the overlay already wins for display) or
 * unmatching and updating the local row.
 *
 * The filter handler is in apps/crm-api/src/shared/utils/typeormFilterBuilder.ts;
 * normalization is mirrored in libs/shared/src/utils/license-effective-fields.ts
 * (`normalizeForDiscrepancy`). Keep those two definitions aligned so the
 * tab count and the per-row indicator never disagree.
 */
export const discrepanciesList: ListBuilderList = {
	id: 'default-licenses-discrepancies',
	cacheTTL: 300000,
	name: 'Discrepancies',
	type: 'default',
	active: true,
	sortOrder: 6,
	filterRules: {
		licenseHasRegistryDiscrepancy: {
			defaultValue: { id: 'yes', label: 'Has Discrepancy' },
			locked: true,
			hidden: true,
		},
		licenseSalesRep: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
		},
	},
	inheritsFrom: 'default-licenses-all',
};
